/* eslint-disable @typescript-eslint/no-unsafe-call */
import { App } from 'vue';

declare const STAGE: string;
declare const ROLLBAR_TOKEN: string;

const rollbarConfig = {
	accessToken: ROLLBAR_TOKEN,
	captureUncaught: false,
	captureUnhandledRejections: false,
	payload: {
		environment: STAGE,
	},
	checkIgnore: window['rollbarIgnore'],
};

const rollbar = (window && window['rollbar'] && window['rollbarIgnore']) ? new window['rollbar'](rollbarConfig) : null;

export default {
	install: (app: App<Element>): void => {
		app.config.errorHandler = (error: any): void => {
			if (((STAGE === 'prd' || STAGE === 'tst')) && rollbar) {
				rollbar.error(error);
			}

			throw error;
		};
	},
};
